import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const taxes = lazyWithRetry(() => import("./routes/index"));

const taxesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/taxes",
  component: () =>
    renderProtectedRoute(taxes, { requirePerms: ["taxes:read"] }),
});

export const taxesRouteTree = [taxesRoute];
